import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["withCoupon", "content"];
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { PaymentMethods } from '@chegg/payment-methods';
import { clearPaymentMethodsCommands, savePaymentMethodsCommands } from '../../redux/command/command.slice';
import { isArrayEmptyOrNull } from '../../utils/ObjectUtils';
import { MessageType } from '../../redux/message/message.types';
import { MessageBox } from '../MessageBox';
import CouponWrapper from '../Coupon';
import { callback as _callback, executeReviewView, updateReviewStep, showOrderPreview } from './helper';
import { Namespace, fireStatusUpdate, DropInPaymentsCommandNames, PaymentMethodsCommandNames, StatusTypes, SharedCommandNames } from '@chegg/commerce-utils';
import { Divider } from './styled';
import { ProjectName } from '../../constants/AppConstants';
import { saveReviewData } from '../../redux/review/review.slice';
import { saveFraudData } from '../../redux/fraud/fraud.slice';
import OrderSummaryWrapper from '../OrderSummaryWrapper/OrderSummaryWrapper';
import { OrderPreviewWrapper } from '../OrderPreviewWrapper/OrderPreviewWrapper';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/config/config.selectors';
import { reviewSelector } from '../../redux/review/review.selectors';
import { paymentMethodsCommandSelector } from '../../redux/command/command.selectors';
import { cartSelector } from '../../redux/cart/cart.selectors';
import { messageSelector } from '../../redux/message/message.selectors';
import { appModeSelector } from '../../redux/appMode/appMode.selectors';
import useRecurlyCheckout from '../../hooks/useRecurlyCheckout';
import { getClient } from '@chegg-web-tools/apollo-utils';
import { saveCartInfo } from '../../redux/cart/cart.slice';
var hasPushedHistory = false;
export var REVIEW_STEP = 2;
export var isWindowDefined = typeof window !== 'undefined';
var DropInPayments = function DropInPayments(props) {
  var _ref;
  var dispatch = useDispatch();
  var stateConfig = useAppSelector(configSelector);
  var review = useAppSelector(reviewSelector);
  var message = useAppSelector(messageSelector);
  var cart = useAppSelector(cartSelector);
  var appMode = useAppSelector(appModeSelector);
  var commands = useAppSelector(paymentMethodsCommandSelector);
  var cartId = cart.cartId,
    items = cart.items,
    taxInfo = cart.taxInfo;
  var subscriptionPrice = cart.subtotalWithCurrencyFormat;
  var taxWithoutCurrency = taxInfo === null || taxInfo === void 0 ? void 0 : taxInfo.tax;
  var totalWithoutCurrency = taxInfo === null || taxInfo === void 0 ? void 0 : taxInfo.totalWithTax;
  useRecurlyCheckout();
  var _stateConfig$ui = stateConfig.ui,
    paymentMethodsRenderFailed = _stateConfig$ui.paymentMethodsRenderFailed,
    displayServerErrors = _stateConfig$ui.displayServerErrors;
  var onError = function onError() {
    return Promise.resolve({});
  };
  var config = props.config,
    optimizelyClient = props.optimizelyClient;
  var withCoupon = config.withCoupon,
    content = config.content,
    rest = _objectWithoutProperties(config, _excluded);
  var reviewStepEnabled = review.reviewStepEnabled,
    currentStep = review.currentStep,
    taxWithCurrencyFormat = review.taxWithCurrencyFormat,
    totalWithCurrencyFormat = review.totalWithCurrencyFormat,
    subtotalWithCurrencyFormat = review.subtotalWithCurrencyFormat,
    renewalPriceWithCurrencyFormat = review.renewalPriceWithCurrencyFormat,
    itemHasFreeTrial = review.itemHasFreeTrial,
    totalWithoutCurrencyFormat = review.totalWithoutCurrencyFormat;
  var apolloClient = getClient();
  useEffect(function () {
    if (!isArrayEmptyOrNull(commands)) {
      dispatch(clearPaymentMethodsCommands());
    }
  }, [commands]);
  useEffect(function () {
    var forterTokenReadyFn = function forterTokenReadyFn(evt) {
      dispatch(saveFraudData(evt.detail));
    };
    document.addEventListener('ftr:tokenReady', forterTokenReadyFn);
    var unmountForterListener = function unmountForterListener() {
      document.removeEventListener('ftr:tokenReady', forterTokenReadyFn);
    };
    return unmountForterListener;
  }, []);
  useEffect(function () {
    reviewStepEnabled && currentStep === 2 && executeReviewView(dispatch);
    currentStep && updateReviewStep(currentStep);
    // no easy was to mock fire window popstate in jest. Test added to Testcafe.
    if (isWindowDefined) {
      if (reviewStepEnabled && currentStep === 2) {
        if (typeof history.pushState === 'function') {
          // this is a workaround for the currentStep getting set to 2 twice issue for new user + new mop case.
          if (!hasPushedHistory) {
            history.pushState(Date.now(), ProjectName, null);
            hasPushedHistory = true;
          }
          window.onpopstate = function () {
            // Handle the browser back button here, will NOT handle refresh
            dispatch(saveReviewData({
              currentStep: 1
            }));
            dispatch(savePaymentMethodsCommands([{
              commandName: PaymentMethodsCommandNames.RESET_FIELDS
            }]));
            fireStatusUpdate([{
              status: StatusTypes.INFO,
              command: DropInPaymentsCommandNames.HISTORY_BACK_CLICK,
              payload: {
                data: {}
              }
            }], Namespace.DROP_IN_PAYMENTS);
            hasPushedHistory = false;
          };
        }
      } else {
        window.onpopstate = function () {};
      }
    }
  }, [currentStep]);
  var subPrice = subtotalWithCurrencyFormat !== null && subtotalWithCurrencyFormat !== void 0 ? subtotalWithCurrencyFormat : subscriptionPrice;

  // Initial price summary. This is used to render the correct tax and total price for Apple Pay.
  var cartPriceSummary = {
    total: (taxInfo === null || taxInfo === void 0 ? void 0 : taxInfo.priceTotalWithTaxCurrency) || '',
    totalWithoutCurrency: totalWithoutCurrency
  };

  // Final price summary which is calculated after billing address is entered. This is used for the order summary.
  var reviewPriceSummary = {
    subscriptionPrice: totalWithoutCurrencyFormat !== 0 && subPrice ? subPrice : renewalPriceWithCurrencyFormat !== null && renewalPriceWithCurrencyFormat !== void 0 ? renewalPriceWithCurrencyFormat : '',
    tax: taxWithoutCurrency !== 0 && taxWithCurrencyFormat ? taxWithCurrencyFormat : '',
    total: totalWithCurrencyFormat !== null && totalWithCurrencyFormat !== void 0 ? totalWithCurrencyFormat : '',
    hasTrial: itemHasFreeTrial !== null && itemHasFreeTrial !== void 0 ? itemHasFreeTrial : false
  };
  var showOrderPreviewParams = {
    cartItems: cart.items,
    currentStep: currentStep,
    country: config.country,
    displayOrderSummary: config.displayOrderSummary,
    appMode: appMode.appModeName
  };
  var showPreview = showOrderPreview(showOrderPreviewParams);
  var isRecurly = config.isRecurly,
    recurlyCart = config.recurlyCart;

  // if a Recurly cart exists, update the pricing data to reflect the Recurly cart attributes
  useEffect(function () {
    if (isRecurly && recurlyCart) {
      var _recurlyCart$orderSum = recurlyCart.orderSummary,
        total = _recurlyCart$orderSum.total,
        subtotal = _recurlyCart$orderSum.subtotal,
        currency = _recurlyCart$orderSum.currencyName;
      dispatch(saveCartInfo({
        items: recurlyCart.items,
        externalId: recurlyCart.externalId
      }));
      dispatch(savePaymentMethodsCommands([{
        commandName: SharedCommandNames.UPDATE_PRICING,
        data: {
          total: total,
          subtotal: subtotal,
          currency: currency
        }
      }]));
    }
  }, [config.recurlyCart]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, displayServerErrors && message.messageType !== MessageType.NONE && /*#__PURE__*/React.createElement(MessageBox, message), /*#__PURE__*/React.createElement(PaymentMethods, {
    config: rest,
    callback: function callback(callbackPayload) {
      _callback({
        response: callbackPayload,
        dispatch: dispatch,
        review: review,
        config: config,
        apolloClient: apolloClient,
        cart: cart
      });
    },
    commands: commands,
    optimizelyClient: optimizelyClient,
    cartPriceSummary: cartPriceSummary
  }), withCoupon && !paymentMethodsRenderFailed && currentStep === 1 && cartId !== '' && items.length > 0 && /*#__PURE__*/React.createElement(CouponWrapper, {
    optimizelyClient: optimizelyClient,
    productFamily: items[0].productType,
    cartId: cartId,
    onError: onError,
    content: content === null || content === void 0 ? void 0 : content.couponContent,
    totalWithCurrencyFormat: (_ref = stateConfig.coupon.totalWithCurrencyFormat || cart.subtotalWithCurrencyFormat) !== null && _ref !== void 0 ? _ref : ''
  }), showPreview && taxInfo && /*#__PURE__*/React.createElement(OrderPreviewWrapper, {
    price: reviewPriceSummary,
    taxInfo: taxInfo
  }), reviewStepEnabled && currentStep === REVIEW_STEP && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(OrderSummaryWrapper, {
    price: reviewPriceSummary
  })));
};
export default DropInPayments;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/components/DropInPayments/DropInPayments.js
// module id = 1471
// module chunks = 11